"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManualTaskHttpClient = void 0;
const atlas_engine_sdk_1 = require("@atlas-engine/atlas_engine_sdk");
const index_1 = require("../Types/index");
const BaseClient_1 = require("./BaseClient");
const Mappers_1 = require("./Lib/Mappers");
class ManualTaskHttpClient extends BaseClient_1.BaseClient {
    async query(query, identity, offset, limit, sortSettings) {
        const enhancedQuery = {
            ...query,
            flowNodeType: atlas_engine_sdk_1.BpmnType.manualTask,
        };
        const url = this.buildUrl(index_1.restSettings.paths.queryFlowNodeInstances, offset, limit, enhancedQuery, sortSettings);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const mappedResult = {
            totalCount: response.result.totalCount,
            manualTasks: response.result.flowNodeInstances.map(Mappers_1.mapManualTask),
        };
        return mappedResult;
    }
    async finishManualTask(manualTaskInstanceId, identity) {
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const urlRestPart = index_1.restSettings.paths.finishManualTask
            .replace(index_1.restSettings.params.manualTaskInstanceId, manualTaskInstanceId);
        const url = this.buildUrl(urlRestPart);
        await this.httpClient.put(url, {}, requestAuthHeaders);
    }
    async onManualTaskWaiting(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.manualTaskWaiting, callback, subscribeOnce, identity);
    }
    async onManualTaskFinished(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.manualTaskFinished, callback, subscribeOnce, identity);
    }
    async removeSubscription(identity, subscription) {
        this.removeSocketIoSubscription(identity, subscription);
    }
}
exports.ManualTaskHttpClient = ManualTaskHttpClient;
//# sourceMappingURL=ManualTaskHttpClient.js.map